(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  function bbUgcInit(root) {
    if (!root || root.dataset.bbInit) return;
    root.dataset.bbInit = '1';

    const track = root.querySelector('[data-ugc-track]');
    if (!track) return;
    const cards = Array.from(root.querySelectorAll('.bb-ugc__card'));
    const prev = root.querySelector('[data-ugc-prev]');
    const next = root.querySelector('[data-ugc-next]');
    const videos = Array.from(root.querySelectorAll('.lazy-video'));
    const progressBar = root.querySelector('[data-ugc-progress]');
    const progressWrap = root.querySelector('.bb-ugc__progress');
    const swipeBtn = root.querySelector('[data-ugc-swipe]');
    const viewport = root.querySelector('.bb-ugc__viewport');

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const hydrate = (video) => {
      if (video && !video.src && video.dataset.src) {
        video.src = video.dataset.src;
        video.load();
      }
    };

    // Tembel yükleme: kart yaklaşınca kaynağı bağla
    if ('IntersectionObserver' in window) {
      const lazy = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              hydrate(e.target);
              obs.unobserve(e.target);
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
      videos.forEach((v) => lazy.observe(v));
    }

    // İçerik satıra sığıyorsa ortala, taşıyorsa başa hizala
    function updateLayout() {
      const fits = track.scrollWidth <= track.clientWidth + 2;
      track.classList.toggle('is-centered', fits);
      const controls = root.querySelector('.bb-ugc__nav-controls');
      if (controls) controls.style.display = fits ? 'none' : '';
      // İçerik sığıyorsa ipuçlarına gerek yok
      if (progressWrap) progressWrap.style.visibility = fits ? 'hidden' : '';
      if (fits) root.classList.add('is-scrolled');
    }

    // İlerleme çubuğu + ilk kaydırmada ipucunu gizle
    function updateProgress() {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0 || !progressBar) return;
      const thumb = Math.max(15, (track.clientWidth / track.scrollWidth) * 100);
      const ratio = track.scrollLeft / max;
      progressBar.style.width = thumb + '%';
      progressBar.style.left = ratio * (100 - thumb) + '%';
      if (track.scrollLeft > 10) root.classList.add('is-scrolled');
    }

    function updateArrows() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 10;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 10;
    }

    const step = () => (cards[0] ? cards[0].offsetWidth + 20 : 320);

    if (prev && next) {
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    }

    // Mobil kaydırma oku: medyanın dikey ortasına hizala, tıklayınca ilerle, sonda gizle
    function positionSwipe() {
      if (!swipeBtn || !viewport) return;
      const media = root.querySelector('.bb-ugc__media');
      if (!media) return;
      const vpRect = viewport.getBoundingClientRect();
      const mRect = media.getBoundingClientRect();
      swipeBtn.style.top = mRect.top - vpRect.top + mRect.height / 2 + 'px';
    }

    function updateSwipe() {
      if (!swipeBtn) return;
      const max = track.scrollWidth - track.clientWidth;
      const atEnd = max <= 0 || track.scrollLeft >= max - 10;
      swipeBtn.classList.toggle('is-hidden', atEnd);
    }

    if (swipeBtn) {
      swipeBtn.addEventListener('click', () => {
        root.classList.add('is-scrolled');
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    // Merkeze en yakın videoyu oynat
    function playCenterVideo() {
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let closest = null;
      let min = Infinity;
      videos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        if (rect.right < 0 || rect.left > window.innerWidth) {
          video.pause();
          return;
        }
        const d = Math.abs(center - (rect.left + rect.width / 2));
        if (d < min) {
          min = d;
          closest = video;
        }
      });
      videos.forEach((video) => {
        if (video === closest) {
          hydrate(video);
          video.play().catch(() => {});
          video.classList.add('is-playing');
        } else {
          video.pause();
          video.classList.remove('is-playing');
        }
      });
    }

    // Sürükleyerek kaydırma (masaüstü)
    let isDown = false;
    let didDrag = false;
    let startX = 0;
    let scrollStart = 0;
    track.addEventListener('mousedown', (e) => {
      isDown = true;
      didDrag = false;
      startX = e.pageX - track.offsetLeft;
      scrollStart = track.scrollLeft;
    });
    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      setTimeout(() => track.classList.remove('is-dragging'), 0);
      setTimeout(playCenterVideo, 120);
    };
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const walk = (e.pageX - track.offsetLeft - startX) * 1.4;
      if (Math.abs(walk) > 5) {
        e.preventDefault();
        track.classList.add('is-dragging');
        didDrag = true;
      }
      track.scrollLeft = scrollStart - walk;
    });
    // Sürükleme sonrası kartı yanlışlıkla açma
    track.addEventListener(
      'click',
      (e) => {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );

    // Hover ile oynat
    if (window.matchMedia('(hover: hover)').matches) {
      videos.forEach((v) => {
        const wrap = v.closest('.bb-ugc__video-wrap');
        if (!wrap) return;
        wrap.addEventListener('mouseenter', () => {
          hydrate(v);
          videos.forEach((o) => {
            if (o !== v) {
              o.pause();
              o.classList.remove('is-playing');
            }
          });
          v.play().catch(() => {});
          v.classList.add('is-playing');
        });
      });
    }

    let scrollTimer;
    track.addEventListener(
      'scroll',
      () => {
        updateProgress();
        updateSwipe();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          if (!isDown) {
            playCenterVideo();
            updateArrows();
          }
        }, 150);
      },
      { passive: true }
    );

    // Görünürlük: videoları oynat/duraklat + mobilde tek seferlik "dürtme"
    let nudged = false;
    function nudge() {
      if (nudged || !isMobile || reduceMotion) return;
      if (track.scrollLeft > 5) return;
      nudged = true;
      const peek = Math.min(70, track.scrollWidth - track.clientWidth);
      if (peek <= 0) return;
      setTimeout(() => {
        track.scrollTo({ left: peek, behavior: 'smooth' });
        setTimeout(() => track.scrollTo({ left: 0, behavior: 'smooth' }), 750);
      }, 500);
    }

    if ('IntersectionObserver' in window) {
      const vis = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            playCenterVideo();
            nudge();
          } else {
            videos.forEach((v) => v.pause());
          }
        },
        { threshold: 0.2 }
      );
      vis.observe(root);
    }

    updateLayout();
    updateArrows();
    updateProgress();
    positionSwipe();
    updateSwipe();
    // Görseller/videolar yüklendikçe medya yüksekliği değişebilir › oku yeniden hizala
    window.addEventListener('load', positionSwipe);
    window.addEventListener('resize', () => {
      updateLayout();
      updateArrows();
      updateProgress();
      positionSwipe();
      updateSwipe();
    });
  }

  function bbUgcInitAll() {
    document.querySelectorAll('.bb-ugc').forEach(bbUgcInit);
  }

  if (document.readyState !== 'loading') bbUgcInitAll();
  else document.addEventListener('DOMContentLoaded', bbUgcInitAll);

  // Tema editöründe blok eklenince yeniden başlat
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.bb-ugc').forEach(bbUgcInit);
  });

  } catch(e) { console.error(e); }
})();
})();
